import React from 'react';
import { get } from 'lodash';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';

import Schema from '../../../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import SonstigeKostenVN, { GetVNSonstigesKostenFormStruc } from './SonstigeKostenVN';
const P = Schema.attributes;

export const GetSonstigesKostenVN = (application: any, kostenKategories: any) => {
	const OrgaStruc = [
		{
			label: 'Antragsteller',
			content: (
				<SonstigeKostenVN kostentraeger="Antragsteller" unternehmenId={get(getLocalstorageToken(), 'organisationId')} />
			),
			formStruc: GetVNSonstigesKostenFormStruc(
				application,
				get(getLocalstorageToken(), 'organisationId'),
				'Antragsteller',
				kostenKategories,
			),
		},
	];
	const PartnerStruc = get(application, P.Partner.path, []).map((ele: any, i: number) => {
		return {
			label: `Partner ${i + 1}`,
			content: <SonstigeKostenVN kostentraeger="Projektpartner" unternehmenId={get(ele, 'Unternehmen.id')} />,
			formStruc: GetVNSonstigesKostenFormStruc(application, get(ele, 'Unternehmen.id'), 'Projektpartner', kostenKategories),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
